import { render } from "./ErrorTrends.vue?vue&type=template&id=917b8d96&scoped=true"
import script from "./ErrorTrends.vue?vue&type=script&lang=js"
export * from "./ErrorTrends.vue?vue&type=script&lang=js"

import "./ErrorTrends.vue?vue&type=style&index=0&id=917b8d96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917b8d96"]])

export default __exports__